import { BaseEntity } from "yt-ng-framework";

export class EkranskaKarticaKomitenata extends BaseEntity{
    constructor(){
        super();
    }

    ID: number = null;
    Komitent: string = null;
    Mesto: string = null;
    Pib: string = null;
    DonosDuguje: number;
    DonosPotrazuje: number;
    DonosUkupno: number;
    TekuceDuguje: number;
    TekucePotrazuje: number;
    TekuceUkupno: number;
    UkupnoDuguje: number;
    UkupnoPotrazuje: number;
    Ukupno: number;
    Telefon: string;
    Email: string;
   

    Deserialize(input: any){
        this.ID = input.ID;
        this.Komitent = input.Komitent;
        this.Mesto = input.Mesto;
        this.Pib = input.Pib;
        this.DonosDuguje = input.DonosDuguje;
        this.DonosPotrazuje = input.DonosPotrazuje;
        this.DonosUkupno = input.DonosUkupno;
        this.TekuceDuguje = input.TekuceDuguje;
        this.TekucePotrazuje = input.TekucePotrazuje;
        this.TekuceUkupno = input.TekuceUkupno;
        this.UkupnoDuguje = input.UkupnoDuguje;
        this.UkupnoPotrazuje = input.UkupnoPotrazuje;
        this.Ukupno = input.Ukupno;
        this.Telefon = input.Telefon;
        this.Email = input.Email;
        
        return this;
    }

    Serialize(input: EkranskaKarticaKomitenata): {} {
        return input;
    }
}